export default class introLanguageSelector {
    constructor() {
        return {
            restrict: 'E',
            replace: true,
            scope: '@',
            template: require('../../../../views/intro/intro-language-selector.html'),
            controller: [
                '$scope', '$element', '$attrs', '$filter', '$rootScope', '$window', 'Translate', 'Setting', 'Events', 'SenderDetailsValidator', 'Rest',
                (scope, element, attrs, $filter, $rootScope, $window, Translate, Setting, Events, SenderDetailsValidator, Rest) => {

                scope.hasShown = $window.localStorage.getItem('introHasShown') ? $window.localStorage.getItem('introHasShown') : false;
                scope.languages = Translate.getAvailableLanguages();
                scope.changeLanguage = (selected) => {
                    scope.language = selected;
                    Translate.useLanguage(selected);

                    Setting.setLanguage(selected).then(() => {
                        Events.flashEvent('notification', $filter('translate')('SETTING:FLASH:ADDED_LANGUAGE_MESSAGE'));
                    }, () => {
                        Events.flashEvent('error', $filter('translate')('SETTING:FLASH:ADDED_LANGUAGE_ERROR_MESSAGE'));
                    });
                };

                scope.closeModal = () => {
                    if (!scope.language) {
                        Events.flashEvent('error', $filter('translate')('SETTING:FLASH:SHOULD_SELECT_LANGUAGE'));
                    } else {
                        $rootScope.$broadcast('intro:language:selected');
                        $window.localStorage.setItem('introHasShown', true);
                        $(element).hide();
                    }
                };

                scope.showModal = () => {
                    if(document.referrer) {
                        var url = new URL(document.referrer);
                        return url.pathname == "/signup/confirm" && scope.sender && !scope.hasShown;
                    }

                    return false;
                };

                Setting.getLanguage().then((res) => {
                    if (res) {
                        scope.language = res.language;
                    }
                });

                Setting.findSenderDetail().then((res) => {
                    if (res) {
                        const details = Rest.rest.stripRestangular(res);
                        scope.sender = details;
                        if (details.custom_fields) {
                            scope.sender.custom_fields = JSON.parse(details.custom_fields);
                            $rootScope.$broadcast('sender:hasCustomFields', scope.sender.custom_fields);
                        }
                    }
                });

                scope.updateSenderDetail = () => {
                    if (!SenderDetailsValidator.validate(scope.sender)) {
                        angular.forEach(SenderDetailsValidator.errors, (errorTranslation) => {
                            Events.flashEvent('error', $filter('translate')(errorTranslation));
                        });

                        return;
                    }

                    Setting.updateSenderDetail(scope.sender).then(() => {
                        Events.flashEvent('notification', $filter('translate')('SETTING:FLASH:UPDATE'));
                    }, (error) => {
                        if (error.status == 400) {
                            if (error.data.message == "Invalid URL given.") {
                                Events.flashEvent('error', $filter('translate')('SETTING:ERROR:INVALID_UNSUBSCRIPTION_URL'));
                            } else {
                                // Show "Something went wrong". Since it should already be validated through frontend.
                                Events.flashEvent('error', $filter('translate')('SETTING:ERRORS:SENDER_NAME'));
                            }
                        }
                    })
                };
            }]
        }
    }
}

